import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {StatistiquesEGAlimService} from "../../../core/services/egalim/statistiques-egalim.service";
import {findSeuilEgalim, SeuilEgalimDto} from "../../../core/dtos/egalim/seuil-egalim-dto";
import {CritereEgalimEnum} from "../../../core/enums/egalim/critere-egalim-enum";
import {StatistiqueEgalimConformite} from "../../../core/dtos/egalim/statistique-egalim-conformite";
import {UtilsService} from "../../../core/utils/utils.service";
import {StatistiqueEgalimDTO} from "../../../core/dtos/egalim/statistique-egalim-dto";
import {GraphQLService} from "../../../core/services/technique/graphql.service";
import {DisplayEgalimResponse} from "../../../core/dtos/gestionmenus/planning/egalim/display-egalim-response-dto";

@Component({
    selector: 'yo-statistiques-egalim-conformite-dialog',
    templateUrl: './statistiques-egalim-conformite-dialog.component.html',
    styleUrls: ['./statistiques-egalim-conformite-dialog.component.scss'],
    standalone: false
})
export class StatistiquesEgalimConformiteDialogComponent implements OnInit, OnDestroy {

  public isDisplayed: boolean = false;

  public isLoading: boolean = false;

  private statistique: StatistiqueEgalimDTO;

  public data: StatistiqueEgalimConformite = new StatistiqueEgalimConformite();

  private subOpen: Subscription;

  constructor(private utilsSvc: UtilsService,
              private graphQlSvc: GraphQLService,
              private statEgalimSvc: StatistiquesEGAlimService) {
  }

  ngOnInit(): void {
    this.initSubOpen();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpen);
  }

  initSubOpen() {
    this.subOpen = this.statEgalimSvc.onOpenStatistiquesEGAlimConformiteDialog$.subscribe((statistiqueEgalim: StatistiqueEgalimDTO) => {
      this.isLoading = true
      this.data = new StatistiqueEgalimConformite();
      this.statistique = statistiqueEgalim;

      this.retreiveThresholds(statistiqueEgalim.site.id).add(result => {
          this.calulConformite(statistiqueEgalim.id, this.data.seuils)
        }
      );
      this.isDisplayed = true;
    });
  }

  calulConformite(statistiqueId: number, seuils: SeuilEgalimDto[]) {
    this.statEgalimSvc.getConformite(statistiqueId,
                                     findSeuilEgalim(seuils, CritereEgalimEnum.BIO),
                                     findSeuilEgalim(seuils, CritereEgalimEnum.PRODUITS_DURABLES),
                                     findSeuilEgalim(seuils, CritereEgalimEnum.POISSON_VIANDE_DURABLE)).subscribe(result => {
      if (result) {
        this.initData(result.one);
      }
    });
  }

  onChangeSeuil($event: SeuilEgalimDto[]) {
    this.calulConformite(this.statistique.id, $event);
  }

  private retreiveThresholds(siteId: number): Subscription {
    return this.graphQlSvc.sendQuery(`
      {
        allUnitesProduction(filters: {
          idsSites: [${siteId}]
        }) {
          egalimThresholdBio,
          egalimThresholdSustainableProducts,
          egalimThresholdPoissonViandeDurable
        }
    }`).subscribe(result => {
      if (result) {
        const seuils = result.allUnitesProduction[0];

        this.initSeuils(seuils.egalimThresholdBio, seuils.egalimThresholdSustainableProducts, seuils.egalimThresholdPoissonViandeDurable)
      }
    });
  }

  /**
   * Même ordre que les valeurs et la légende de la jauge (durables, bio, viandes et poissons),
   * pour que chaque champ de seuil soit aligné sous le critère qu'il pilote.
   */
  private initSeuils(seuilBio: number, seuilDurable: number, seuilViandePoisson: number) {
    this.data.seuils = [
      new SeuilEgalimDto(CritereEgalimEnum.PRODUITS_DURABLES, "Seuil Produits Durables", seuilDurable),
      new SeuilEgalimDto(CritereEgalimEnum.BIO, "Seuil Bio", seuilBio),
      new SeuilEgalimDto(CritereEgalimEnum.POISSON_VIANDE_DURABLE, "Seuil Viandes et Poissons Durables", seuilViandePoisson)
    ];
  }

  private initData(response: DisplayEgalimResponse) {
    this.isLoading = false;

    this.initSeuils(response.egalimThresholdBio, response.egalimThresholdSustainableProducts, response.egalimThresholdPoissonViandeDurable);

    this.data.annee = this.statistique.annee;
    this.data.isConforme = response.egalim;
    this.data.pointTeledeclarationLibelle = this.statistique.pointTeledeclaration.libelle;
    this.data.pourcentageBio = response.pourcentageBio;
    this.data.pourcentageDurable = response.pourcentageDurable;
    this.data.pourcentageMontantProduitsPoissonViande = response.pourcentageMontantProduitsPoissonViande;

  }

  customizeTextLabelGaugeEgalim: (arg: any) => string = arg => `${arg.valueText} %`;

  customizeTooltipGaugeEgalim: (arg: any) => string = (arg): any => ({
    text: this.getText(arg, arg.valueText),
  });

  customizeTextGaugeEgalim: (arg: any) => string = (arg): any => this.getText(arg.item, arg.text);

  private getText = (item: any, value: string) => {
    switch (item.index) {
      case 0:
        return `Pourcentage de produits durables ${value} %`;
      case 1:
        return `Pourcentage de produits bio ${value} %`;
      default:
        return `Pourcentage de viandes et poissons durables ${value} %`;
    }
  }
}
